import { atom, selector, useRecoilValue, useSetRecoilState } from "recoil";
import { tiers } from "Constants";

export const User = atom({
  key: "User",
  default: {
    token: "",
    name: "",
    tier: "",
    completedCollegeFinder: false,
    picture: "",
    id: "",
    email: "",
  },
});

export const UserWithPremiumStatus = selector({
  key: "UserWithPremiumStatus",
  get: ({ get }) => {
    const user = get(User);
    return {
      ...user,
      isPremiumUser:
        user.tier === tiers.ACHIEVER || user.tier === tiers.MENTORED,
    };
  },
});

export const useUserInfo = () => {
  const setUser = useSetRecoilState(User);
  const user = useRecoilValue(UserWithPremiumStatus);
  return { user, setUser };
};
